
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.89.531h1.344v5.516c0 .838.292 1.258.875 1.258.276 0 .537-.104.782-.313l.32.453c-.547.453-1.091.68-1.633.68-1.125 0-1.687-.659-1.687-1.977V.531z","fill":"currentColor"}})])
          )
        }
      }
    